import React from 'react';
import moment from "moment";

const Footer = () => {

    return (
        
        <footer className="main-footer text-center text-sm d-flex justify-content-center justify-content-md-between align-items-center ">
            <span style={{fontSize:'1.1rem'}}>Customer Support (8am to 10pm Mon-Fri) : (617) 683 1899</span>
            <span style={{fontSize:'1.1rem'}} className="d-none d-md-block">© 2016 - {moment().format('YYYY')} Hisably. All Rights Reserved.</span>
            
        </footer>
    );
};

export default Footer;
